<template>
	<nk-box v-if="context" variant="sidebar">
		<nk-meta size="base">Zuständiges Amt</nk-meta>
		<hr />

		<nk-link :link="context.detailURL" block>
			<nk-title size="lg">
				{{ context.titel }}
			</nk-title>
		</nk-link>
		<nk-address
			variant="vertical"
			v-bind="{...context.kontakt, ...context.adresse}"
		/>
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 */
export default {
	name: 'NkSidebarAmt',

	mixins: [TemplatesDefault],
};
</script>
